const loadGalaxyComponents = () => {
    const scriptElm = document.createElement('script');
    scriptElm.src = window.urlGalaxyComponents;
    document.body.appendChild(scriptElm);
};

export default () => {
	if (window.urlGalaxyComponents) {
		document.addEventListener('lazybeforeunveil', e => {
			if (e.target.tagName === 'GALAXY-MAGIC') {
				e.target.removeAttribute('force-inactive');
			}
		});

		loadGalaxyComponents();
	}
}
